import React from 'react';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {connect} from 'react-redux';
import { withRouter } from 'react-router';
import Dialog from 'material-ui/Dialog';
import shallowCompare from 'react-addons-shallow-compare';
import { fetchReadOnlyResponse, copyResponse } from '../actions/responses';
import {getResponse, calculateResults, getResults, answerTextLookup} from '../reducer/response';
import LinearProgress from 'material-ui/LinearProgress';
import moment from 'moment';
import md5 from 'js-md5';
import TextField from 'material-ui/TextField';
import StartNewFisheryDialog from '../components/StartNewFisheryDialog';
import Papa from 'papaparse';
import { makeTitle, questionsAndAnswers, sortedCategories } from '../reducer';
import { updateFisheryMetadata } from "../actions/response";
import FisheryMetadataDialog from '../components/FisheryMetadataDialog';
import {downloadCSV} from '../Reports/ReportHelpers';
import {questionsForSection, BOTH} from '../Reports/ReportHelpers';
import ReportGenerator from "../components/ReportGenerator";
import { questionLookup } from "../reducer/questions";
import textVersion from 'textversionjs';
import {assessmentTiers} from "../components/resultItems/AssessmentTier";
import {toColorStr} from "../Reports/AdminExports"
import {SECTION_TITLES} from "./AnswersList"
import MultiExportsPopUp from "../components/MultiExportsPopUp";

const RESULTS_URL = "https://tool.fishpath.org/questionnaire/results/";

class ResponseHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      shareDialogOpen: false,
      csvDialogOpen: false,
      saveDialogOpen: false,
      readOnlyDialogOpen: false,
      newFisheryDialogOpen: false,
      saving: false,
      copying: false,
      metadataOpen: false,
      showGenRptModal: false,
      showMultiExportModal: false
    };
  }

  componentDidMount() {
    if (this.props.readOnly && !this.props.answers) {
      this.props.fetchReadOnlyResponse(this.props.responseID);
    }
  }

  componentWillUnmount() {
    if (this.saveCheckInterval) {
      clearInterval(this.saveCheckInterval);
    }
    document.body.style.backgroundColor = "#e6e1d8"
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  copyFishery() {
    if (!this.props.loggedIn) {
      alert("You must be signed in to copy a fishery");
    } else {
      this.setState({copying: true});
    }
  }

  copyFisherySave = (attrs) => {
    this.props.copyResponse(attrs, () => {
      this.setState({copying: false});
      window.location = "/home";
    });
  }

  render() {
    let { fetching, readOnly, responseID, inResults, inAnswers, inHarvestStrategy, shareable, notSaved, isYou } = this.props;
    const { copying } = this.state;
    let {  createdAt, editedAt }  = this.props.metadata || {};
    let { name, email } = this.props || {};
    let reportType = inAnswers ? "answers" : "results";
    let section = this.props.params.section;
    let disablePDF = (section && inResults) ? !this.props.results[section].complete : false;

    if (inResults) {
      let starredOptIDs = (this.props.response.userEdits[section] && this.props.response.userEdits[section].starred) ?
        this.props.response.userEdits[section].starred : [];
      document.body.style.backgroundColor = readOnly ? "rgba(255, 102, 0, 0.5)" : "#e6e1d8";
      return  (
        <Card style={{position: "relative", maxWidth: 1280, margin: '0 auto', marginBottom: 20}}>
          <CardHeader title={fetching ? "Retrieving Response" : makeTitle(this.props) || "FishPath Submission"} avatar={`https://www.gravatar.com/avatar/${md5(email || "name@example.com")}?d=mm`} subtitle={ fetching ? null : <span><a target="_blank" rel="noopener noreferrer" href={`mailto:${email}`}>{isYou ? "You" : name}</a> {notSaved ? "created" : "submitted"} this response on {moment(editedAt || createdAt).format('llll')}</span>} />
          { fetching ? null :
          <div>
            {readOnly ? <CardText style={{border: '3px solid orange', backgroundColor:"rgba(255, 102, 0, 0.5)"}}>
                <b><a href="https://fishpath.github.io/FishPath-Tool-User-Guide/fishpath-tool-interactive-results-page.html#view-only-mode-shared-fishery" target="_blank" rel="noopener noreferrer">View-Only Mode</a>: You cannot make any edits to the results or answers. If you wish to edit, you may make a copy of this fishery to save to your account.</b>
              </CardText> : null}
            <CardActions style={{textAlign: "left"}}>
              { shareable ? <RaisedButton primary={true} label="Share" onClick={this.share.bind(this)} /> : null }
              <FlatButton onClick={() => this.setState({csvDialogOpen: true})} label="Export CSV" />
              {
                //TODO: update report for HS page
                !inHarvestStrategy && <FlatButton onClick={this.onGenerateReportClick.bind(null, section)} label="Generate PDF Report" disabled={disablePDF} />
              }
              <FlatButton onClick={this.copyFishery.bind(this)} label="Copy Fishery" />
              {!readOnly && <FlatButton onClick={() => this.setState({metadataOpen: true})} label="Edit Name and Details" />}
              {(!inAnswers && !inHarvestStrategy) && <FlatButton onClick={this.onMultiExportClick.bind(null)} label="Multiple Fisheries CSVs" />}
            </CardActions>
          </div>
          }
          {
            copying && (
              <FisheryMetadataDialog
                copying={true}
                modal={false}
                isNew={false}
                onRequestClose={() => this.setState({ copying: false })}
                open={this.state.copying}
                metadata={this.props}
                handleSave={this.copyFisherySave}
              />
            )
          }
          { fetching ? <LinearProgress mode="indeterminate" /> : null }
          <Dialog title="Share" modal={false} open={this.state.shareDialogOpen} onRequestClose={() => this.setState({shareDialogOpen: false})}>
            Copy the link below to share this response. Users of this link will be able to review these results but not change the original answers.
            <br />
            <TextField id="urlCopy" ref="urlCopy" value={`${RESULTS_URL}${responseID}/${section}`} style={{width: "100%"}} />
          </Dialog>
          <Dialog title="Export to CSV" modal={false} open={this.state.csvDialogOpen} onRequestClose={() => this.setState({csvDialogOpen: false})}>
            <FlatButton label="Download Answers" onClick={this.downloadAnswers} />
            <FlatButton label="Download Results Summary" onClick={this.downloadResultSummary} />
            <FlatButton label="Download Results" onClick={this.downloadResultMatrix} />
          </Dialog>
          <StartNewFisheryDialog
            open={this.state.newFisheryDialogOpen}
            onRequestClose={() => this.setState({newFisheryDialogOpen: false})}
            clearResponse={this.props.clearResponse}
            notSaved={notSaved}
            readOnly={readOnly}
            router={this.props.router}
          />
          { this.state.metadataOpen && <FisheryMetadataDialog
            modal={false}
            isNew={false}
            onRequestClose={() => this.setState({ metadataOpen: false })}
            open={this.state.metadataOpen}
            metadata={this.props}
            handleSave={this.handleMetadataUpdate}
          />}
          <Dialog
            open={this.state.showGenRptModal}
            autoScrollBodyContent={true}
            actions={[
              <FlatButton
                label="Cancel"
                onClick={this.closeGenRptModal.bind(this)}
              />,
              <RaisedButton
                onClick={this.handleGenerateReports}
                primary={true}
                label="Generate Report"
              />
            ]}
            title={reportType === "results" ? "Reports" : "Choose page layout options for the answer report:"}
          >
            <ReportGenerator
              rptType={reportType}
              options={this.state.reportOptions}
              answerTextLookup={this.props.answerTextLookup}
              answers={this.props.answers}
              questionLookup={this.props.questionLookup}
              monitoringQuestions={this.props.monitoringQuestions}
              assessmentQuestions={this.props.assessmentQuestions}
              controlRulesQuestions={this.props.controlRulesQuestions}
              categories={this.props.categories}
              sections={['monitoring', 'assessment', 'controlRules']}
              notesList={this.props.userNotes}
              section={section}
              fishery={makeTitle(this.props)}
              ref="reportGenerator"
              starred={starredOptIDs}
              translation={this.props.translation}
            />
          </Dialog>
          <Dialog
            open={this.state.showMultiExportModal}
            autoScrollBodyContent={true}
            actions={[
              <FlatButton
                label="Cancel"
                onClick={this.closeMultiExportModal.bind(this)}
              />,
              <RaisedButton
                onClick={this.handleMultiExports}
                primary={true}
                label="Generate Report"
              />
            ]}
            title={"Export Comparison for Multiple Fisheries - " + SECTION_TITLES[section]}

          >
            {(!inAnswers && !inHarvestStrategy) && <MultiExportsPopUp
              viewedResponse={this.props.response}
              section={section}
              ref="multiExportPopUp"
              options={this.props.results[section].options}
              answerTextLookup={this.props.answerTextLookup}
              answers={this.props.answers}
              questionLookup={this.props.questionLookup}
              monitoringQuestions={this.props.monitoringQuestions}
              assessmentQuestions={this.props.assessmentQuestions}
              controlRulesQuestions={this.props.controlRulesQuestions}
              categories={this.props.categories}
              translation={this.props.translation}
              calculateResults={answers =>
                calculateResults(
                  this.props.questions,
                  answers,
                  this.props.options,
                  this.props.categories,
                  this.props.tags
                )
              }
            />}
          </Dialog>
        </Card>
      );
    } else {
      return null;
    }
  }

  onMultiExportClick = () => {
    this.setState({
      showMultiExportModal: true
    })
  };

  handleMultiExports = () => {
    let exportType = this.refs.multiExportPopUp.state.exportType
    this.refs.multiExportPopUp.genExport(exportType);
    this.closeMultiExportModal();
  }

  closeMultiExportModal(){
    this.setState({
      showMultiExportModal:false
    })
  }

  onGenerateReportClick = (section) => {
    this.setState({
      showGenRptModal: true,
      //if filtering only top options then only show those in here as well
      reportOptions: this.props.inAnswers ? null : this.props.filterOptions[section].shortList ? this.props.filteredResults[section].options.filter(
          o => this.props.response.userEdits[section] ? this.props.response.userEdits[section].starred.indexOf(o.id) !== -1 : false
        ) : this.props.filteredResults[section].options
    });
  };

  handleGenerateReports = () => {
    let reportType = this.refs.reportGenerator.state.tabValue;
    this.refs.reportGenerator.genReports(reportType);
    this.closeGenRptModal();
  };

  closeGenRptModal() {
    this.setState({
      showGenRptModal: false
    });
  };

  handleMetadataUpdate = (attrs) => {
    this.props.handleFisheryMetadataSave(attrs, this.props.responseID);
    this.setState({metadataOpen: false});
  }

  startNewFishery() {
    this.props.clearResponse();
    setTimeout(() => {
      this.props.router.push("/");
    }, 100);
  }

  share() {
    this.setState({shareDialogOpen: true})
    setTimeout(() => {
      this.refs.urlCopy.focus()
      this.refs.urlCopy.select()
    }, 100);

  }


  downloadAnswers = () => {
    let answers = this.props.answers;
    let rows = [["Bookmarked", "Question", "Category", "Description", "Possible Answers","Answer", "Note"]];
    var secQuestions;
    let section = this.props.params.section ? this.props.params.section : "monitoring" //TODO: update for harvest strategy page instead of defaulting to monitoring
    if(section === "monitoring"){
      secQuestions = this.props.monitoringQuestions;
    } else if(section === "assessment"){
      secQuestions = this.props.assessmentQuestions;
    } else if(section === "controlRules"){
      secQuestions = this.props.controlRulesQuestions;
    } //else if(section === "enforcement"){ //TODO: add enforcementQuestions to props
    //   secQuestions = this.props.enforcementQuestions
    // }
    for (var questionID in answers) {
      let question = this.props.questions.find((q) => q.id.toString() === questionID);
      if (question && secQuestions.find((q) => q.id === question.id )) {
        let answer = question.answers.find((a) => a.id === answers[questionID].value);
        let possibleAnswers = question.answers.map((a) => a.title).join("\n");
        if (answer) {
          var note = answers[questionID].note ? textVersion(answers[questionID].note) : "";
          var bookmark = answers[questionID].flagged ? "Yes" : "";
          var category = this.props.categories.find((c) => c.id === question.category);

          var qTitle = question.title
          var catTitle = category.title
          var desc = question.description
          var answerText = answer.title

          if(this.props.translation){
            var trQ = this.props.translation.questions.find(trQ => trQ.engID === question.id)
            if(trQ){
                qTitle = trQ.title
                desc = trQ.description
                let catTr = this.props.translation.categories.find((c) => c.engID === category.id)
                catTitle = catTr ? catTr.title : catTitle
                possibleAnswers = trQ.answers.map((a) => a.title).join("\n");
                answerText = trQ.answers.find(a => a.id === answer.id).title
            }
          }

          rows.push([bookmark, qTitle.replace(/<.*?>/gm, ''), catTitle , desc.replace(/<.*?>/gm, ''), possibleAnswers, answerText, note])
        }
      }
    }
    var csv = Papa.unparse(rows);
    downloadCSV(csv, this.props.commonName + " Answers - " + SECTION_TITLES[section])
  }

  downloadResultSummary = () => {
    let results = this.props.results;
    let rows = [[
      "Section", "Category", "Option", "Eliminated", "# red caveats", "# orange caveats", "# yellow caveats", "# grey caveats", "# green caveats"
    ]];
    for (var section of ["monitoring", "assessment", "controlRules", "enforcement"]) {
      if (results[section].complete) {
        let options = results[section].options.concat(results[section].eliminatedOptions);
        for (var option of options) {
          let row = [];
          if (section === "monitoring") {
            row.push("Data Collection");
          } else if (section === "assessment") {
            row.push("Assessment");
          } else if(section === "controlRules"){
            row.push("Management Measures");
          } else if(section === "enforcement"){
            row.push("Enforcement")
          }
          row = row.concat([
            option.category.title,
            option.title,
            option.eliminated,
            option.caveats.filter((c) => c.score === -3).length,
            option.caveats.filter((c) => c.score === -2).length,
            option.caveats.filter((c) => c.score === -1).length,
            option.caveats.filter((c) => c.score === 0).length,
            option.caveats.filter((c) => c.score === 2).length
          ]);
          rows.push(row);
        }
      }
    }
    var csv = Papa.unparse(rows);
    downloadCSV(csv, this.props.commonName + " Results Summary")
  }

  downloadResultMatrix = () => {
    // option cav by option and question for single Fishery
    let results = this.props.results;
    var section=this.props.params.section ? this.props.params.section : "monitoring" //TODO: update for harvest strategy page instead of defaulting to monitoring
    var optionsList = results[section].options;
    var questions = this.props.questions.filter((q) => q.answerType === 'normal')
    var sectionQuestions;
    if(section === "monitoring"){
      sectionQuestions = this.props.monitoringQuestions;
    } else if(section === "assessment"){
      sectionQuestions = this.props.assessmentQuestions;
    } else if(section === "controlRules"){
      sectionQuestions = this.props.controlRulesQuestions;
    }
    var response = this.props.response
    var userAnswers = response.answers
    var userEdits = response.userEdits

    var titleArr = ["","","","",""];
    var questionDescArr = ["","","","",""];
    var possibleAnsArr = ["","","","",""];
    var givenAnswerArr = [ "","","","",""];
    var answerNoteArr = ["","","","",""];
    var bookmarkArr =  ["","","","",""];
    var subTitleArr = []
    subTitleArr.push("Top Option")
    subTitleArr.push("ID");
    subTitleArr.push("Option Name");
    if(section === "assessment"){
      subTitleArr.push("Output Category")
      subTitleArr.push("Input Category");
      subTitleArr.push("Assessment Tier");
      titleArr.push("","")
      questionDescArr.push("","");
      possibleAnsArr.push("","");
      givenAnswerArr.push("","");
      answerNoteArr.push("","");
      bookmarkArr.push("","");
    } else {
      subTitleArr.push("Category")
    }
    titleArr.push("Question")
    questionDescArr.push("Question Description")
    possibleAnsArr.push("Possible Answers")
    givenAnswerArr.push("Answer Given")
    answerNoteArr.push("Answer Note")
    bookmarkArr.push("Bookmarked");
    subTitleArr.push("Option Notes")
    subTitleArr.push("Static Caveats");

    sectionQuestions.forEach((question) => {
      var answer = question.answers.find((a) => a.id.toString() === userAnswers[question.id].value.toString())

      var qTitle = question.title
      var desc = question.description
      var answerText = answer.title
      var possibleAnswers = question.answers.map((a) => a.title).join("\n");

      if(this.props.translation){
        var trQ = this.props.translation.questions.find(trQ => trQ.engID === question.id)
        if(trQ){
            qTitle = trQ.title
            desc = trQ.description
            possibleAnswers = trQ.answers.map((a) => a.title).join("\n");
            answerText = trQ.answers.find(a => a.id === answer.id).title
        }
      }

      titleArr.push(question.id + ":" + qTitle.replace(/<.*?>/gm, ''));
      questionDescArr.push(textVersion(desc));
      possibleAnsArr.push(textVersion(possibleAnswers));
      givenAnswerArr.push(textVersion(answerText))
      var answerNote = userAnswers[question.id].note ? textVersion(userAnswers[question.id].note) : ''
      answerNoteArr.push(answerNote)
      var bookmark = userAnswers[question.id].flagged ? "X" : ""
      bookmarkArr.push(bookmark)
    })

    var finalArr = [];
    finalArr.push(titleArr, bookmarkArr, questionDescArr, possibleAnsArr, givenAnswerArr, answerNoteArr, subTitleArr);


    optionsList.forEach((option) => {
      var rowArr = [];
      var topOptionText = userEdits[section].starred.includes(option.id) ? "X" : ""
      rowArr.push(topOptionText)
      rowArr.push(option.id);
      rowArr.push(option.title);
      var category = this.props.categories.find((c) => c.id === option.category.id);
      console.log("cat:" + category)
      rowArr.push(category ? category.title : "",);
      if(section === "assessment"){
        var inputCat = this.props.categories.find((c) => c.id === option.inputCategory);
        rowArr.push(inputCat ? inputCat.title : "",);
        let assessmentTierTitle = assessmentTiers.find(tier => tier.id === option.assessmentTier).title;
        rowArr.push(assessmentTierTitle ? assessmentTierTitle : "",);
      }

      //option notes
      var optNote = userEdits.userNotes[option.id] ? textVersion(userEdits.userNotes[option.id]) : ''
      rowArr.push(optNote)

      //static caveats
      var staticCavs = [];
      var category = this.props.categories.find((c) => c.id === option.category);
      option.additionalCaveats.forEach((addCav) => {
        staticCavs.push({
          option_id: option.id,
          title: option.title,
          static_Caveat: addCav.title,
          score: addCav.score,
          category: category ? category.title : null,
          section: option.section
        })
      });

      var sCavsForOpt = staticCavs.filter(sCav => sCav.option_id.toString() === option.id.toString());
      var sCavText = sCavsForOpt.map((sCav) => sCav.static_Caveat).join("\n")
      rowArr.push(sCavText);

      //caveats for options
      var caveats = [];
      sectionQuestions.forEach((question) => {
        //check the option to see if there is a caveat for the question, if so add it to the caveat array
        var caveat = option.caveats.find((c) => c.question === question.id);
        var answer = question.answers.find((a) => a.id.toString() === userAnswers[question.id].value.toString())
        if(caveat){
          caveats.push({
            question: question.title.replace(/<.*?>/gm, ''),
            answer: answer.title,
            caveat: caveat.title,
            score: caveat.score,
            option: option.title,
            category: option.category,
            section: option.section,
            option_id: option.id,
            answer_id: answer.id,
            question_id: question.id
          })
        }
      });

      var cavsForOpt = caveats.filter(cav => cav.option_id.toString() === option.id.toString())

      sectionQuestions.forEach((question) => {
        var exists = cavsForOpt.filter((cav) => cav.question_id === question.id)
        if(exists.length) {
          var answerStr = "";
          exists.forEach((cav) => {
            answerStr +=  toColorStr(cav.score) + ": " + cav.answer + " : " + cav.caveat + "\n"
          })
          answerStr = answerStr.substring(0, answerStr.length - 1); //remove extra \n
          rowArr.push(answerStr);
        } else {
          rowArr.push("");
        }
      })
        finalArr.push(rowArr);
    })

    var csv = Papa.unparse(finalArr);
    downloadCSV(csv, this.props.commonName + " Results - " + SECTION_TITLES[section])
  }

}

let mapStateToProps = (state, ownProps) => {
  let response = getResponse(state);
  let readOnly = response ? state.auth.email !== response.email && !state.auth.isAdmin : false;
  const filteredResults = getResults(state);
  let trIDForResponse = (response && response.userEdits) ? response.userEdits.trIDForResponse : -1;
  let translation = (trIDForResponse !== -1) ? state.translations.find((t) => t.id === trIDForResponse) : null;
  return {
    ...response,
    isYou: response ? state.auth.email === response.email : false,
    answers: response ? response.answers : null,
    readOnly: readOnly,
    fetching: readOnly ? state.responses.fetching : false,
    response: response,
    responseID: ownProps.params.id,
    inResults: ownProps.inResults,
    shareable: true,
    notSaved: false,
    saveCompleted: !state.sync.localChanges,
    questions: state.questions,
    options: state.options,
    tags: state.tags,
    results: response ? calculateResults(state.questions, response.answers, state.options, state.categories, state.tags) : null,
    loggedIn: state.auth.email,
    filterOptions: state.filterOptions,
    answerTextLookup: answerTextLookup(state),
    questionLookup: questionLookup(state),
    userNotes: response ? (response.userEdits || {}).userNotes || {} : {},
    filteredResults: filteredResults,
    categories: sortedCategories(state),
    monitoringQuestions: questionsAndAnswers.monitoring(state),
    assessmentQuestions: questionsAndAnswers.assessment(state),
    controlRulesQuestions: questionsAndAnswers.controlRules(state),
    translation: translation
  }
}

let mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchReadOnlyResponse: (id) => dispatch(fetchReadOnlyResponse(id)),
    copyResponse: (attrs, callback) => dispatch(copyResponse(ownProps.params.id, attrs, callback)),
    handleFisheryMetadataSave: (attrs, id) => dispatch(updateFisheryMetadata(attrs, id))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResponseHeader));
